import { IAsset } from "@/v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";

import { StateType } from "../useRequestsStore";

export const addAssetToQueue = (asset: IAsset, { set }: StateType, triggerWatcher = true) => {
  set(({ queue, activeRequests }) => ({
    queue: [...queue, asset],
    ...(triggerWatcher && { activeRequests: [...activeRequests, asset] }),
  }));
};
